// Generated by Melange

import DropdownMenuModuleCss from "./dropdownMenu.module.css";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_int32 from "melange.js/caml_int32.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Shared__Popover from "./popover.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__Element from "melange-webapi/Webapi/Dom/Webapi__Dom__Element.jsx";
import * as Webapi__Dom__HtmlElement from "melange-webapi/Webapi/Dom/Webapi__Dom__HtmlElement.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = DropdownMenuModuleCss;

const context = React.createContext(undefined);

const make = context.Provider;

function use(param) {
  return Stdlib__Option.get(React.useContext(context));
}

const Context = {
  context: context,
  make: make,
  use: use
};

function DropdownMenu$Root(Props) {
  let children = Props.children;
  const isOpenRef = React.useRef(false);
  const menuId = React.useId();
  const preventNextToggleRef = React.useRef(false);
  const triggerId = React.useId();
  const value = React.useMemo((function () {
    return {
      isOpenRef: isOpenRef,
      menuId: menuId,
      preventNextToggleRef: preventNextToggleRef,
      triggerId: triggerId
    };
  }), [
    menuId,
    triggerId
  ]);
  return JsxRuntime.jsx(make, {
    value: value,
    children: JsxRuntime.jsx(Shared__Popover.Root.make, {
      children: children
    })
  });
}

const Root = {
  make: DropdownMenu$Root
};

function DropdownMenu$Trigger(Props) {
  let children = Props.children;
  const match = use(undefined);
  const preventNextToggleRef = match.preventNextToggleRef;
  const menuId = match.menuId;
  const isOpenRef = match.isOpenRef;
  return JsxRuntime.jsx(Shared__Popover.Reference.make, {
    children: React.cloneElement(children, {
      "aria-controls": menuId,
      "aria-haspopup": "menu",
      id: match.triggerId,
      popovertarget: menuId,
      onPointerDown: (function (param) {
        if (isOpenRef.current) {
          preventNextToggleRef.current = true;
          return;
        }
        
      })
    })
  });
}

const Trigger = {
  make: DropdownMenu$Trigger
};

function DropdownMenu$Content(Props) {
  let children = Props.children;
  let className = Props.className;
  let placement = Props.placement;
  let strategy = Props.strategy;
  const menuRef = React.useRef(null);
  const match = use(undefined);
  const triggerId = match.triggerId;
  const preventNextToggleRef = match.preventNextToggleRef;
  const isOpenRef = match.isOpenRef;
  React.useEffect((function () {
    const menuEl = menuRef.current;
    if (menuEl == null) {
      return;
    }
    const abortController = new AbortController();
    menuEl.addEventListener("beforetoggle", (function ($$event) {
      if ($$event.newState === "open" && preventNextToggleRef.current) {
        preventNextToggleRef.current = false;
        $$event.preventDefault();
        return;
      }
      
    }), {
      signal: abortController.signal
    });
    return (function (param) {
      abortController.abort();
    });
  }), []);
  let tmp = {
    children: React.cloneElement(JsxRuntime.jsx("div", {
      ref: menuRef,
      children: children,
      "aria-labelledby": triggerId,
      className: Clsx(className, css.root),
      id: match.menuId,
      role: "menu",
      onKeyDown: (function ($$event) {
        Stdlib__Option.iter((function (selectedMenuItem) {
          const menu = $$event.currentTarget;
          const match = $$event.code;
          let exit = 0;
          switch (match) {
            case "ArrowDown" :
            case "ArrowRight" :
              exit = 2;
              break;
            case "ArrowLeft" :
            case "ArrowUp" :
              exit = 1;
              break;
            case "End" :
              $$event.preventDefault();
              $$event.stopPropagation();
              Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt(menu.querySelector("[role=menuitem]:last-child")), Webapi__Dom__Element.asHtmlElement)).focus();
              return;
            case "Escape" :
              $$event.preventDefault();
              $$event.stopPropagation();
              Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt(document.getElementById(triggerId)), Webapi__Dom__Element.asHtmlElement)).focus();
              return;
            case "Home" :
              $$event.preventDefault();
              $$event.stopPropagation();
              Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt(menu.querySelector("[role=menuitem]:first-child")), Webapi__Dom__Element.asHtmlElement)).focus();
              return;
            default:
              if (Array.from($$event.key).length !== 1) {
                return;
              }
              $$event.preventDefault();
              $$event.stopPropagation();
              const menuItems = Array.prototype.slice.call(menu.querySelectorAll("[role=menuitem]"));
              const currentIndex = menuItems.indexOf(selectedMenuItem, undefined);
              const pressedCharacter = $$event.key.toLowerCase();
              return Stdlib__Option.iter((function (prim) {
                prim.focus();
              }), Stdlib__Option.bind(Caml_option.undefined_to_opt(menuItems.slice(currentIndex + 1 | 0, undefined).concat(menuItems.slice(undefined, currentIndex)).find(function (node) {
                return node.textContent.toLowerCase().startsWith(pressedCharacter, undefined);
              })), Webapi__Dom__HtmlElement.ofNode));
          }
          switch (exit) {
            case 1 :
              $$event.preventDefault();
              $$event.stopPropagation();
              const menuItems$1 = Array.prototype.slice.call(menu.querySelectorAll("[role=menuitem]"));
              const currentIndex$1 = menuItems$1.indexOf(selectedMenuItem, undefined);
              const len = menuItems$1.length;
              Stdlib__Option.get(Stdlib__Option.bind(Stdlib__Option.bind(Belt__Belt_Array.get(menuItems$1, Caml_int32.mod_((currentIndex$1 + len | 0) - 1 | 0, len)), Webapi__Dom__Element.ofNode), Webapi__Dom__Element.asHtmlElement)).focus();
              return;
            case 2 :
              $$event.preventDefault();
              $$event.stopPropagation();
              const menuItems$2 = Array.prototype.slice.call(menu.querySelectorAll("[role=menuitem]"));
              const currentIndex$2 = menuItems$2.indexOf(selectedMenuItem, undefined);
              const len$1 = menuItems$2.length;
              Stdlib__Option.get(Stdlib__Option.bind(Stdlib__Option.bind(Belt__Belt_Array.get(menuItems$2, Caml_int32.mod_(currentIndex$2 + 1 | 0, len$1)), Webapi__Dom__Element.ofNode), Webapi__Dom__Element.asHtmlElement)).focus();
              return;
          }
        }), Stdlib__Option.bind(Webapi__Dom__Element.asHtmlElement($$event.target), (function (target) {
          const role = target.role;
          if (role === "menuitem") {
            return Caml_option.some(target);
          } else {
            return Stdlib__Option.bind(Caml_option.nullable_to_opt(target.closest("[role=menuitem]")), Webapi__Dom__Element.asHtmlElement);
          }
        })));
      }),
      onBlur: (function ($$event) {
        Stdlib__Option.iter((function (relatedTarget) {
          const currentTarget = $$event.currentTarget;
          if (!currentTarget.contains(relatedTarget)) {
            return currentTarget.hidePopover();
          }
          
        }), Caml_option.nullable_to_opt($$event.relatedTarget));
      })
    }), {
      popover: "auto",
      onToggle: (function ($$event) {
        const newState = $$event.newState;
        isOpenRef.current = newState === "open";
        if (newState !== "open") {
          return;
        }
        const firstMenuItem = Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt($$event.currentTarget.querySelector("[role=menuitem]:first-child")), Webapi__Dom__HtmlElement.ofElement));
        setTimeout((function (param) {
          firstMenuItem.focus();
        }), 0);
      })
    })
  };
  if (placement !== undefined) {
    tmp.placement = Caml_option.valFromOption(placement);
  }
  if (strategy !== undefined) {
    tmp.strategy = Caml_option.valFromOption(strategy);
  }
  return JsxRuntime.jsx(Shared__Popover.Content.make, tmp);
}

const Content = {
  make: DropdownMenu$Content
};

function DropdownMenu$Item(Props) {
  let children = Props.children;
  let onClick = Props.onClick;
  let type_Opt = Props.type_;
  const type_ = type_Opt !== undefined ? type_Opt : "button";
  const match = use(undefined);
  let tmp = {
    children: children,
    className: css.item,
    role: "menuitem",
    type: type_
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.cloneElement(JsxRuntime.jsx("button", tmp), {
    popovertarget: match.menuId,
    popovertargetaction: "hide"
  });
}

const Item = {
  make: DropdownMenu$Item
};

const useDropdownMenuContext = use;

export {
  Context,
  useDropdownMenuContext,
  Root,
  Trigger,
  Content,
  Item,
}
/* css Not a pure module */
